export default {
    props: {
        fixedAmount: {
            type: Number,
            required: false,
            default: null
        }
    },
    computed: {
        validatedFixedAmount() {
            if (this.fixedAmount && this.fixedAmount > 0) {
                return this.fixedAmount;
            }
            return null;
        }
    },
    methods: {
        getAmountToDisplay(amountString) {
            return this.validatedFixedAmount 
                ? this.$format.currency(this.validatedFixedAmount)
                : amountString;
        },
        getAmountTooltip(tooltipIfFixedAmount, defaultTooltip) {
            return this.validatedFixedAmount 
                ? tooltipIfFixedAmount
                : defaultTooltip;
        }
    }
}